import React from "react";
import PictureDisplay from "../../components/PictureDisplay"

export const ImageModule = (props) => {
  const {
    url,
    opacity,
    backgroundColor,
    ratio,
    linkEnabled,
    link,
    srcset
  } = props.settings;

  const defaultImage = "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Untersberg_Mountain_Salzburg_Austria_Landscape_Photography_%28256594075%29.jpeg/1280px-Untersberg_Mountain_Salzburg_Austria_Landscape_Photography_%28256594075%29.jpeg";

  const imageStyle = {  
    height: "auto",
    maxWidth: "100%",
    maxHeight: "100%",
    opacity
  };

  if (ratio == "LOCK") {
    return (
      <>
        <div
          style={
            {
              backgroundColor,
              width: "100%",
              height: "100%",
              textAlign: "center",
              overflow: "hidden",
              cursor: linkEnabled ? "cursor" : "default"
            }
          }
          onClick={() => {
            if (linkEnabled == true && link) {
              window.open(link, "_blank");
            }
          }}
        >
          {url ?
            <PictureDisplay
              src={url}
              srcset={srcset}
              style={imageStyle}
            />
            :
            <img
              style={imageStyle}
              src={defaultImage}
            />
          }
        </div>
      </>
    );
  }

  return (
    <div
      style={{
        backgroundColor,
        overflow: "hidden",
        width: "100%",
        height: "100%",
        cursor: linkEnabled ? "pointer" : "default",
      }}
      onClick={() => {
        if (linkEnabled == true && link) {
          window.open(link, "_blank");
        }
      }}
    >
      <PictureDisplay
        src={url ? url : defaultImage}
        srcset={srcset}
        style={
          {
            objectFit: "cover",
            overflow: "hidden",
            width: "100%",
            height: "100%",
            opacity
          }
        }
      />
    </div>
  );
};